import { nameEntity, nameSource } from '../domain/info'
import { headers } from '../domain/headers'
import { breadcrumbList } from '../domain/breadcrumb'
import { toolsList } from '../domain/tools'
import { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import moment from 'moment'
import Form, { Select } from 'components/Form'
import { DateInput } from 'components/Form/date'
import { FilterContainer } from './styles'
import api from 'services/api'
import { apiListActiveMenuFoodTypes, apiListInstitution } from '../domain/api'
import { useToast } from 'hooks/toast'
import {
  FORMS_PAYAMENT,
  SITUATION_TYPES_CONTRACT
} from 'commons/constants/commercial'
import Container from 'components/Container'
import DataTable from 'components/DataTable'
import { CheckboxMultiSelect } from '../../ContractsUpdates/components/CheckboxMultiSelect'

const ContractList = (): JSX.Element => {
  const { addToast } = useToast()
  const [startDate, setStartDate] = useState<Date>()
  const [finalDate, setFinalDate] = useState<Date>()
  const [situation, setSituation] = useState<string>()
  const [formPayament, setFormPayament] = useState<string>()
  const [institutionOptions, setInstitutionOptions] = useState<
    IInstitutionData[]
  >([])
  const [menuFoodTypeOptions, setMenuFoodTypeOptions] = useState<
    { value: number; label: string }[]
  >([])
  const [selectedMenuFoodTypeIds, setSelectedMenuFoodTypeIds] = useState<
    number[]
  >([])
  const [institution, setInstitution] = useState<string>()
  const [parameters, setParameters] = useState<any>()
  const history = useHistory()
  const location = new URLSearchParams(useLocation().search)

  useEffect(() => {
    api
      .get(apiListInstitution())
      .then(res => {
        const orderedData = res.data
          .filter((institution: IInstitutionData) => institution.is_active)
          .sort((a: IInstitutionData, b: IInstitutionData) =>
            a.company_social_name.localeCompare(b.company_social_name)
          )
        setInstitutionOptions(orderedData)
      })
      .catch(() => {
        addToast({
          type: 'error',
          title: 'Erro ao carregar as instituições',
          description:
            'Houve um erro ao carregar as instituições disponíveis no banco de dados.'
        })
      })
    api
      .get(apiListActiveMenuFoodTypes())
      .then(res => {
        const ordered = (res.data as IMenuFoodType[]).sort((a, b) =>
          a.name.localeCompare(b.name)
        )
        setMenuFoodTypeOptions(
          ordered.map(menuFoodType => ({
            value: menuFoodType.id,
            label: menuFoodType.name
          }))
        )
      })
      .catch(() => {
        addToast({
          type: 'error',
          title: 'Erro ao carregar os cardápios',
          description:
            'Houve um erro ao carregar os tipos de cardápio disponíveis.'
        })
      })
  }, [addToast])

  const buildSearchParameters = () => {
    const hasFilter =
      startDate ||
      finalDate ||
      situation ||
      formPayament ||
      institution ||
      selectedMenuFoodTypeIds.length > 0

    if (!hasFilter) {
      return []
    }

    return [
      {
        form_payament: formPayament || undefined,
        start_date: startDate
          ? moment(startDate).format('YYYY-MM-DD')
          : undefined,
        end_date: finalDate
          ? moment(finalDate).format('YYYY-MM-DD')
          : undefined,
        institution_id: institution || undefined,
        situation: situation || undefined,
        menu_food_type_ids: selectedMenuFoodTypeIds.length
          ? selectedMenuFoodTypeIds
          : undefined
      }
    ]
  }

  const onSearch = async () => {
    const query = []
    if (formPayament) {
      query.push(`form_payament=${formPayament}`)
    }
    if (startDate) {
      query.push(`start_date=${moment(startDate).format().substring(0, 10)}`)
    }
    if (finalDate) {
      query.push(`end_date=${moment(finalDate).format().substring(0, 10)}`)
    }
    if (situation) {
      query.push(`situation=${situation}`)
    }
    if (institution) {
      query.push(`institution_id=${institution}`)
    }
    if (selectedMenuFoodTypeIds.length) {
      query.push(`menu_food_type_ids=${selectedMenuFoodTypeIds.join(',')}`)
    }

    history.replace(
      query.length
        ? `/commercial/contracts?${query.join('&')}`
        : '/commercial/contracts'
    )
    setParameters(buildSearchParameters())
  }

  useEffect(() => {
    const formPayamentParam = location.get('form_payament')
    const createdAt = location.get('created_at')
    const startDateParam = location.get('start_date')
    const finalDateParam = location.get('end_date')
    const situationParam = location.get('situation')
    const institutionParam = location.get('institution_id')
    const menuFoodTypeIdsParam = location.get('menu_food_type_ids')

    const hasAny =
      startDateParam ||
      finalDateParam ||
      situationParam ||
      formPayamentParam ||
      createdAt ||
      institutionParam ||
      menuFoodTypeIdsParam

    if (!hasAny) {
      setParameters([])
      return
    }

    if (formPayamentParam) {
      setFormPayament(formPayamentParam)
    }
    if (startDateParam) {
      setStartDate(moment(`${startDateParam} 00:00:00`).toDate())
    }
    if (finalDateParam) {
      setFinalDate(moment(`${finalDateParam} 00:00:00`).toDate())
    }
    if (situationParam) {
      setSituation(situationParam)
    }
    if (institutionParam) {
      setInstitution(institutionParam)
    }
    if (menuFoodTypeIdsParam) {
      setSelectedMenuFoodTypeIds(
        menuFoodTypeIdsParam.split(',').map(id => Number(id))
      )
    }

    const menuFoodTypeIds = menuFoodTypeIdsParam
      ? menuFoodTypeIdsParam.split(',').map(id => Number(id))
      : []

    setParameters([
      {
        created_at: createdAt || undefined,
        form_payament: formPayamentParam || undefined,
        start_date: startDateParam || undefined,
        end_date: finalDateParam || undefined,
        institution_id: institutionParam || undefined,
        situation: situationParam || undefined,
        menu_food_type_ids: menuFoodTypeIds.length ? menuFoodTypeIds : undefined
      }
    ])
  }, [])

  return (
    <Container
      pageTitle="Listagem"
      breadcrumb={breadcrumbList}
      tools={toolsList}
    >
      <FilterContainer>
        <Form onSubmit={onSearch} defaultValues={{}} className="col-md-12">
          <div className="col-md-12 d-flex flex-wrap">
            <div className="col-md-3 pe-8">
              <Select
                label="Instituição"
                name="institution_id"
                options={institutionOptions?.map(institution => {
                  return {
                    name: institution.company_social_name,
                    value: institution.id
                  }
                })}
                onChange={e => setInstitution(e.target.value)}
                value={institution}
                blank
                controlled
                defaultValue={''}
              />
            </div>
            <div className="col-md-3 pe-8">
              <Select
                label="Forma de pagamento"
                name="form_payament"
                options={FORMS_PAYAMENT?.map(form_payament => {
                  return {
                    name: form_payament,
                    value: form_payament
                  }
                })}
                onChange={e => setFormPayament(e.target.value)}
                value={formPayament}
                blank
                controlled
                defaultValue={''}
              />
            </div>
            <div className="col-md-2 pe-8">
              <DateInput
                label="Data inicial"
                name="start_date"
                onChange={date => setStartDate(date)}
                selected={startDate}
                controlled
              />
            </div>
            <div className="col-md-2 pe-8">
              <DateInput
                label="Data final"
                name="end_date"
                onChange={date => setFinalDate(date)}
                selected={finalDate}
                controlled
              />
            </div>
            <div className="col-md-2">
              <Select
                label="Situação"
                name="situation"
                options={SITUATION_TYPES_CONTRACT}
                onChange={e => setSituation(e.target.value)}
                value={situation}
                controlled
                blank
                defaultValue={''}
              />
            </div>
          </div>
          <div className="col-md-12 d-flex flex-wrap">
            <div className="col-md-4 pe-8">
              <CheckboxMultiSelect
                label="Cardápios"
                fieldId="menu_food_type_ids"
                options={menuFoodTypeOptions}
                selectedValues={selectedMenuFoodTypeIds}
                onChange={values =>
                  setSelectedMenuFoodTypeIds(values.map(Number))
                }
                placeholder="Todos"
              />
            </div>
          </div>
          <footer className="col-md-12 d-flex justify-content-end pb-5 gap-5">
            <button
              type="reset"
              className="btn btn-secondary btn-sm"
              onClick={() => {
                setStartDate(undefined)
                setFinalDate(undefined)
                setSituation(undefined)
                setInstitution(undefined)
                setFormPayament(undefined)
                setSelectedMenuFoodTypeIds([])
              }}
            >
              LIMPAR
            </button>
            <button type="submit" className="btn btn-primary btn-sm">
              BUSCAR
            </button>
          </footer>
        </Form>
        <hr />
      </FilterContainer>

      <div>
        <h3 className="h3 pt-6">Listagem</h3>
      </div>
      {parameters && (
        <DataTable
          source={nameSource}
          entity={nameEntity}
          format={{ orderBy: 'created_at' }}
          orderBySort="DESC"
          headers={headers}
          searchParameters={parameters}
          actions={[
            {
              name: 'Visualizar',
              title: 'Visualizar',
              spanIcon: 'fa fa-search',
              linkTo: contract => `/commercial/contracts/view/${contract.id}`,
              style: { margin: '0 5px' }
            }
          ]}
        />
      )}
    </Container>
  )
}
export default ContractList
